import { Component } from '@theme/component-base';
import { ThemeBus } from '@theme/events-bus';
import { EVENTS } from '@theme/event-constants';

export class DynamicContentComponent extends Component {
    connectedCallback() {
        super.connectedCallback();

        this.contentElement = this.querySelector('[ref="dynamic-source"]');

        if (!this.contentElement) return;

        ThemeBus.addEventListener(EVENTS.variantChange, this.#handleVariantChange);
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        ThemeBus.removeEventListener(EVENTS.variantChange, this.#handleVariantChange);
    }

    #handleVariantChange = (event) => {
        const { variant } = event.detail;
        if (!variant) return;
        this.contentElement.textContent = variant.sku || '';
    };
}

customElements.define('dynamic-content-component', DynamicContentComponent);